import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { of } from 'rxjs/observable/of';
import { timeout } from 'rxjs/operators/timeout';

//Import for messages
import { MessageService } from 'services/message.service'
import { Http, Headers, RequestOptions } from '@angular/http';

import { AuthService } from 'services/auth.service';

import * as _ from 'underscore';
import { PagerService } from 'services/index';
import { GlobalService } from 'services/global.service';

import { Pager } from '../../../pager';

import { HttpClient,HttpHeaders } from '@angular/common/http';
import { switchMap, map, tap } from 'rxjs/operators';

@Injectable()
export class courseFormatService {
  domain = this.authService.domain;
  pagerProcess;
  pager = new Subject<Pager>();
  sorting = "no";
  totalItems = this.globalService.totalItems;
  Acs = true;
  processing = false; // variable for loading fucntion

  courseFormatsAll;
  searchResultZero=false;
  courseFormats = new Subject<any[]>();

  courseFormats$ = this.courseFormats.asObservable();
  pager$ = this.pager.asObservable();

  leftscroller = new Subject<number>();
  leftscroller$ = this.leftscroller.asObservable();
  scrolledLeft=0;

  sortingArray = [
    {
      id : 0,
      title : 'コースフォーマットid',
      sortingType : 'id',
      ascendingStatus : true
    },
    {
      id : 1,
      title : '最終更新日時',
      sortingType : 'updated_at',
      ascendingStatus : false
    }
  ];
  
  courseFormatCsvHeader = [
    {
      title : "no=優先順位",
      alias : "noPriority",
      class : "min-width-120"
    },
    {
      title : "問題文",
      alias : "problemStatement",    
      class : "min-width-400"
    },
    {
      title : "タイプ",
      alias : "type",    
      class : "min-width-120"
    },
    {
      title : "設問グループ",
      alias : "questionGroup",    
      class : "min-width-100"
    },
    {
      title : "Entry",
      alias : "entry",    
      class : "min-width-100 d-none"
    },
    {
      title : "字数制限",
      alias : "characterLimit",    
      class : "min-width-100"
    },
    {
      title : "GAiL利用",
      alias : "usingGail",    
      class : "min-width-100"
    },
    {
      title : "アンケートID",
      alias : "idAngket" ,   
      class : "min-width-100"
    },
    {
      title : "設問ヘッダー",
      alias : "questionHeader"  ,  
      class : "min-width-1000"
    },
    {
      title : "フィードバックフッター",
      alias : "feedbackFooter",    
      class : "min-width-100"
    },
    {
      title : "0",
      alias : "choice0",    
      class : "min-width-100"
    },
    {
      title : "1",
      alias : "choice1",    
      class : "min-width-100"
    },
    {
      title : "2",
      alias : "choice2",    
      class : "min-width-100"
    },
    {
      title : "3",
      alias : "choice3",    
      class : "min-width-100"
    },
    {
      title : "正解",
      alias : "coorectAnswer",    
      class : "min-width-100"
    },
    {
      title : "フィードバック（パターン1）",
      alias : "feedbackPatern1",    
      class : "min-width-600"
    },
    {
      title : "パターン1遷移先(default)",
      alias : "paternTransition1",    
      class : "min-width-100"
    },
    {
      title : "フィードバック（パターン2）",
      alias : "feedbackPatern2",    
      class : "min-width-600"
    },
    {
      title : "パターン2遷移先",
      alias : "paternTransition2",    
      class : "min-width-100"
    },
    {
      title : "フィードバック（パターン3）",
      alias : "feedbackPatern3",    
      class : "min-width-600"
    },
    {
      title : "パターン3遷移先",
      alias : "paternTransition3",    
      class : "min-width-100"
    },
    {
      title : "フィードバック（パターン4）",
      alias : "feedbackPatern4",    
      class : "min-width-600"
    },
    {
      title : "パターン4遷移先",
      alias : "paternTransition4",    
      class : "min-width-100"
    },
    {
      title : "配信タイミング（日）",
      alias : "deliveryTimingDay",    
      class : "min-width-100"
    },
    {
      title : "配信タイミング（時刻）",
      alias : "deliveryTimingHours",    
      class : "min-width-100"
    }
  ];

  //編集モード
  editCourseFormatEditViewMode;

  constructor(
  	private messageService: MessageService,
  	private http: Http,
    private authService: AuthService,
    private pagerService:　PagerService,
    private globalService: GlobalService,
    private httpClient: HttpClient,
  ) {
    this.scrolledLeft=0;
  }

  getData(url: string): Observable<string> {
    return this.httpClient.get(url, { responseType: 'blob', headers:new HttpHeaders({ 'Content-Type': 'text/plain' }) })
      .pipe(
        switchMap(response => this.readFile(response))
      );
  }

  private readFile(blob: Blob): Observable<string> {
    return Observable.create(obs => {
      const reader = new FileReader();

      reader.onerror = err => obs.error(err);
      reader.onabort = err => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();

      return reader.readAsDataURL(blob);
    });
  }

  
  //---------------------------------- Getting API data with subscribe ---------------------------------------------------
  //Getting Login API  

  // Getting All Course Format
  // Type : Get
  // Parse :
  getCourseFormatAPI(){
    return this.http.get(this.domain + 'course_format' , this.authService.options).map(res => res.json());
  }

  // Getting course format by course format ID
  // Type : Get
  // Parse :
  getCourseFormatByIDAPI(ValID){
    return this.http.get(this.domain + 'course_format/' + ValID, this.authService.options).map(res => res.json());
  }

  getQuestionDataByIDAPI(QID){
    return this.http.get(this.domain + 'question/' + QID, this.authService.options).map(res => res.json());
  }

  // Upload CSV And validate the CSV in Backend
  // Type : Post
  // Parse : CSV File
  uploadCsv(formData){
    return this.http.post(this.domain + 'course_format/csv/upload', formData , this.authService.options).pipe(timeout(20000)).map(res => res.json());
  }

  //Insert The New Data By CSV FIle
  // Type : Post
  // Parse : CSV Filename from backend, Course_format_name
  uploadCsvCreate(fileName , dataParse){
    return this.http.post(this.domain + 'course_format/csv/upload/' + fileName , dataParse ,this.authService.options).map(res => res.json());    
  }

  // Updating Course Format data by CSV
  // Type : Post
  // Parse :  CSV Filename from backend, Course_format_name
  uploadCsvUpdate(fileName , dataParse , courseFormatId){
    return this.http.post(this.domain + 'course_format/csv/upload/update/' + courseFormatId + '/' + fileName , dataParse ,this.authService.options).map(res => res.json());    
  }
  
  // Inserting New COurse_format with old course_format data
  // Type : Post
  // Parse : old_course_format ID  , course_format_name
  copyCsvCreate(course_format_id , dataParse){
    return this.http.post(this.domain + 'course_format/copy/' + course_format_id , dataParse ,this.authService.options).map(res => res.json());    
  }

  // getting Course_format id by keyword
  // Type : Post
  // Parse : keyword
  getCourseFormatBySearchApi(SearchValue, SearchFilter=null) {
    var parseValue = {
      keyword : SearchValue,
      filter_kind : SearchFilter
    }
    return this.http.post(this.domain + 'course_format/search'   , parseValue , this.authService.options).map(res => res.json());    
  }

  // getting questions data by course_format_id
  // Type : get
  // Parse : course_format_id
  apiCourseFormatEdit(courseId) {
    const url = this.domain + "course_format/question/" + courseId;
    return this.http.get(url, this.authService.options).map(res => res.json());
  }

  // updating and deleting Image
  // Type : put
  // Parse : question_id , new image
  apiUpdateImg(type, formData, questionId) {
    let url = this.domain + "question/";
    if (type == "feedback") url = url + "feedback/";
    url = url + questionId; // final URL

    return this.http.put(url, formData, this.authService.options).map(res => res.json());
  }
  apiUpdateQuestionData(formData, questionId) {
    let url = this.domain + "question/update/";
    url = url + questionId; // final URL

    return this.http.put(url, formData, this.authService.options).map(res => res.json());
  }
  addQuestionByGui(formData, courseFormatId) {
    console.log('addQuestionByGui');
    let url = this.domain + "question/addByGui/";
    url = url + courseFormatId;
    
    return this.http.put(url, formData, this.authService.options).map(res => res.json());
  }
  unlinkQuestionByGui(formData, courseFormatId) {
    console.log('unlinkQuestionByGui');
    let url = this.domain + "question/unlinkByGui/";
    url = url + courseFormatId;
    
    return this.http.put(url, formData, this.authService.options).map(res => res.json());
  }
  //
  apiUpdateCourseFormatname(formData, courseId) {
    let url = this.domain + "course_format/";
    url = url + courseId; // final URL

    return this.http.put(url, formData, this.authService.options).map(res => res.json());
  }
  //
  apiUpdateCourseFormatActive(activeflag, courseId) {
    let url = this.domain + "course_format/";
    url = url + courseId; // final URL

    return this.http.put(url, {activeflag:activeflag}, this.authService.options).map(res => res.json());
  }

  // checking the file name is id valid or not
  // Type : get
  // Parse : course_format_name
  apiCheckingCourseFormatName(name) {
    let url = this.domain + "course_format/checkCourseFormatName";
    const body = {
      name: name,
    }

    return this.http.post(url, body, this.authService.options).map(res => res.json());
  }

  // ---------------------------------- Process subcribe API data --------------------------------------------------------
   /** @function
    * @name getCourseFormat
    * 
    * @todo getting all course_format from database and seperate the by total items
    *  */
  getCourseFormat(){
   this.getCourseFormatAPI().subscribe( data => {
      this.courseFormatsAll = data;
      this.setPage(1);
   },err => {
    console.log(err);
   })
  }

   /** @function
    * @name getCourseFormatAll
    * 
    * @todo getting all course_format from database and show all
    *  */
  getCourseFormatAll(){
    this.getCourseFormatAPI().subscribe( data => {
       this.courseFormats.next(data);
    },err => {
     console.log(err);
    })
  }

   /** @function
    * @name getCourseFormatAll
    * 
    * @param {string} SearchValue  keyword for search course format
    * @todo getting all course_format by keyword from databaseand seperate by total item
    *  */
  getCourseFormatByFilterAndSearchProcess( SearchValue, SearchFilter=null) {
    this.getCourseFormatBySearchApi(SearchValue, SearchFilter).subscribe( data => {
      this.courseFormatsAll = data;
      if(data.data_length_zero){
        this.searchResultZero=true;
      }else{
        this.searchResultZero=false;
      }
      this.setPage(1);
    },
    err => {
      var res = JSON.parse(err._body);
      if(!res.success){
        this.courseFormatsAll = [];
        this.setPage(1);
      }
    });
  }

   /** @function
    * @name getCourseFormatByFilterAndSearch
    * 
    * @param {string} SearchValue  keyword for search course format
    * @todo getting all course_format by keyword from database and show allc
    *  */
  getCourseFormatByFilterAndSearch(SearchValue,SearchFilter=null){
    if(SearchValue == "" || SearchValue == undefined) {
      if(SearchFilter != null && SearchFilter<2){
        this.getCourseFormatByFilterAndSearchProcess(SearchValue,SearchFilter);
      }else{
        this.getCourseFormat();
      }
    }else{
      this.getCourseFormatByFilterAndSearchProcess(SearchValue,SearchFilter);
    }
  }

   /** @function
    * @name getCourseFormatEdit
    * 
    * @param {string} courseId  id of the course foramt
    * @todo getting question of course_format in edit screen
    *  */
  getCourseFormatEdit(courseId) {
    return new Promise<any>((resolve, reject) => {
      this.apiCourseFormatEdit(courseId).subscribe( data => {
        this.setQuestion(data).then( dataBack => {
          this.courseFormatsAll = dataBack;
          if(this.pagerProcess && this.pagerProcess.currentPage){
            this.setPage(this.pagerProcess.currentPage);
          }else{
            this.setPage(1);
            this.pagerProcess.currentPage=1;
            
          }
          resolve(dataBack);
        });
      },
      err => {
        reject(err);
        console.log(err);
      });  
    });
  }

  setCurrentPageNum(num){
    if(this.pagerProcess && this.pagerProcess.currentPage){
      this.pagerProcess.currentPage=num;
    }
  }

   /** @function
    * @name getCourseFormatByID
    * 
    * @param {string} ValID  id of the course foramt
    * @todo getting course format data by course format id
    *  */
  getCourseFormatByID(ValID) {
    return new Promise<any>((resolve, reject) => {
      this.getCourseFormatByIDAPI(ValID).subscribe( data => {
        resolve(data);
      },
      err => {
        reject(err);
      });  
    });
  }

  getQuestionDataByID(QID) {
    return new Promise<any>((resolve, reject) => {
      this.getQuestionDataByIDAPI(QID).subscribe( data => {
        resolve(data);
      },
      err => {
        reject(err);
      });  
    });
  }

   /** @function
    * @name updateCourseFormatImg
    * 
    * @param {string} type type of the image to upload
    * @param {string} formData image data for uplaod
    * @param {string} questionId  the course_format quesiton id
    * @todo updating the image of course format question 
    *  */
  updateCourseFormatImg(type, formData, questionId) {
    return new Promise<any>((resolve, reject) => {
      this.apiUpdateImg(type, formData, questionId).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  updateQuestionData(form_data,question_id) {
    return new Promise<any>((resolve, reject) => {
      this.apiUpdateQuestionData(form_data, question_id).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  addQuestionDataByGui(form_data,course_format_id) {
    return new Promise<any>((resolve, reject) => {
      this.addQuestionByGui(form_data, course_format_id).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  deleteQuestionLinkingByGui(form_data,course_format_id){
    return new Promise<any>((resolve, reject) => {
      this.unlinkQuestionByGui(form_data, course_format_id).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  //コースフォーマット名を変更する
  updateCourseFormatName(form_data,course_format_id){
    return new Promise<any>((resolve, reject) => {
      this.apiUpdateCourseFormatname(form_data, course_format_id).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

  //コースフォーマットのis_activeを変更する
  updateCourseFormatActive(activeflag,course_format_id){
    return new Promise<any>((resolve, reject) => {
      this.apiUpdateCourseFormatActive(activeflag, course_format_id).subscribe( data => {
        resolve(data);
      },
      err => {
        console.log(err);
        reject(err);
      });
    });
  }

   /** @function
    * @name setPage
    * 
    * @param {string} pagr  number pagination want to show
    * @todo setting the show data by total items and pagination plus sorting the data 
    *  */
  setPage(page: number) {
    if (page < 1) {
      return;
    }
    if(this.courseFormatsAll !== undefined) {
      this.courseFormatsAll = this.pagerService.getSorting(this.courseFormatsAll,this.sorting, this.Acs);
      // get pager object from service
      this.pagerProcess = this.pagerService.getPager(this.courseFormatsAll.length, page, this.totalItems);
      //get current page of items
      this.courseFormats.next(this.courseFormatsAll.slice(this.pagerProcess.startIndex, this.pagerProcess.endIndex + 1)) ;
      this.pager.next(this.pagerProcess);
      //left scrolle 
      if(this.scrolledLeft > 0){
        this.leftscroller.next(this.scrolledLeft);
        this.resetScrollLeft();
      }
    }
  }

  setScrollLeft(scroll){
    this.scrolledLeft=scroll;
  }
  resetScrollLeft(){
    this.scrolledLeft=0;
  }

   /** @function
    * @name setQuestion
    * 
    * @param {string} arrValue  number pagination want to show
    * @todo making structure the question for displaying the question data 
    *  */
  setQuestion(arrValue){
    return new Promise<any>((resolve, reject) => {
      var returnArr = [];
      arrValue.map((val, i) => {
        const obj = {
          ...val.question,
          delivery_date: val.delivery_date,
          delivery_time: val.delivery_time
        }
        returnArr.push(obj);
      });
      resolve(returnArr);
    });
  }
  
   /** @function
    * @name setQuestion
    * 
    * @param {string} body csv data
    * @todo validating the CSV data
    *  */
  validateCsv(body){
    return new Promise<any>((resolve, reject) => {
      var bodyMessage = [];
      var success = true;
      for(var i = 0; i<body.length;i++){
        var checking = [];
        this.pagerService.validateTrueFalse(body[i][4]).then( valid4 => {
          //console.log("benar");
        },invalid4 => {
          //console.log("salah");
          
        })      
      }
      resolve(true);
    });
  }

   /** @function
    * @name checkingCourseName
    * 
    * @param {string} name course format inputed name 
    * @todo cheking the name of the new course format is still available or now 
    *  */
  checkingCourseName(name){
    return new Promise<any>((resolve, reject) => {
      this.apiCheckingCourseFormatName(name).subscribe( result => {
        resolve(result);
      },err => {
        reject(err);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/component/aplication/courseformat/courseformat.service.ts